module.exports = __webpack_public_path__ + "static/media/25-9.e8e4d02b.mp3";